import React, { useState, useEffect } from 'react'
import Lottie from 'lottie-react'
import { Button } from '@mui/material'
import { useNavigate, useLocation } from 'react-router-dom'
import WelcomeScreenanimation from '../Assets/animations/welcomscreenrotation.json'

function Typewriter({ text, speed }) {
    const [displayText, setDisplayText] = useState('');
    const [currentIndex, setCurrentIndex] = useState(0);


    useEffect(() => {
        if (currentIndex < text.length) {
            const timer = setTimeout(() => {
                setDisplayText((prevText) => prevText + text[currentIndex]);
                setCurrentIndex((prevIndex) => prevIndex + 1);
            }, speed);
            return () => clearTimeout(timer);
        }
    }, [currentIndex, speed, text]);

    return (
        <div>
            <p>{displayText}<span style={{ opacity: currentIndex < text.length ? 1 : 0, borderLeft: '2px solid black', marginLeft: '5px', animation: 'blink 0.7s infinite' }}></span></p>
            <style>
                {`
            @keyframes blink {
              50% { border-left-color: transparent; }
            }
          `}
            </style>
        </div>
    );
}

function WelcomeScreen() {
    const navigate = useNavigate()
    const location = useLocation()
      console.log(location.state?.from)

    const textToType = "Your AI-powered integrative Wellness Companion, combining Ayurveda with Modern Science";
    const typingSpeed = 30;

    return <div className='Welcome-page-section'>
        <div className='Welcome-section'>
            <div className='Welcome-section-animation'>
                <Lottie animationData={WelcomeScreenanimation} />
            </div>

            <div>
                <p> <Typewriter text={textToType} speed={typingSpeed} /></p>
            </div>

            <div className='flex flex-col gap-2 Welcome-action-btn items-center' style={{ boxSizing: "border-box" }}>

                <div>
                    <Button
                        style={{
                            width: '100%',
                            textTransform: 'none',
                            borderRadius: '0',
                            backgroundColor: '#DA6E0B', /* Background color */
                            color: 'white', /* Text color for better contrast */
                            border: 'none', /* Remove default border */
                            boxSizing: 'border-box',
                            borderRadius: "5px",
                            fontFamily: "'Poppins', sans-serif",
                            fontWeight: 500,
                            padding: "10px 2rem"
                        }}

                        onClick={() => {
                            navigate('/OnboardUser')
                        }
                        }
                    >
                        New User?
                    </Button>
                </div>

                <div>
                    <Button
                        style={{
                            width: '100%',
                            textTransform: 'none',
                            borderRadius: '0',
                            border: "1px solid #DA6E0B ",
                            color: '#DA6E0B', /* Text color for better contrast */
                            boxSizing: 'border-box',
                            borderRadius: "5px",
                            fontFamily: "'Poppins', sans-serif",
                            fontWeight: 500,
                            padding: "10px 2rem"
                        }}
                        onClick={() => {
                            navigate('/Login', { state: { from: location?.state?.from } })
                        }}
                    >
                        Already Have an Account!
                    </Button>
                </div>

            </div>
        </div>
    </div>
}

export default WelcomeScreen